// Angular's Router stringifies every key of a matrix-params object passed to router.navigate(),
// including keys whose value is undefined/null — which serializes to the literal text "undefined"
// (or "null") in the resulting URL, and comes back that way when the target route reads it from
// ActivatedRoute.params. Once that literal string exists, it's a normal "defined" string value to
// everything downstream (price lookups, order-creation payloads, ...) and gets forwarded as-is.
//
// isRouteParamAbsent/stripUndefinedParams treat a real undefined/null the same as the literal
// strings "undefined"/"null", so the fix works from both ends:
//   - called on an object right before router.navigate([..., obj]), it stops a real undefined from
//     ever being stringified into the URL in the first place;
//   - called on the object handed back from ActivatedRoute.params (or productDetails built from
//     it), it un-corrupts any literal "undefined"/"null" string that already leaked in from a
//     navigate() call this wasn't applied to (e.g. deep links, browser history, another page).
export function isRouteParamAbsent(value: any): boolean {
  return value === undefined || value === null || value === "undefined" || value === "null";
}

export function stripUndefinedParams<T extends Record<string, any>>(params: T): Partial<T> {
  const result: Partial<T> = {};
  for (const key of Object.keys(params) as (keyof T)[]) {
    if (!isRouteParamAbsent(params[key])) {
      result[key] = params[key];
    }
  }
  return result;
}
